export default {
  logout: '登出',
  accountManage: '帳號管理',
  accountSetting: {
    title: '個人資訊',
    form: {
      name: {
        label: '姓名',
        placeholder: '請輸入姓名',
        overlimit: '超過字數限制'
      },
      mobile: {
        label: '手機',
        placeholder: '請輸入手機',
        invalid: '格式不符'
      },
      avatarUploadFaild: '頭像上傳失敗',
      saveFailed: '保存失敗',
      saveSucceed: '保存成功'
    },
  },
  passwordChange: {
    title: '變更密碼',
    form: {
      oldPassword: {
        label: '舊密碼',
        validateFail: '密碼錯誤'
      },
      newPassword: {
        label: '新密碼',
        historyFail: '不符合密碼歷程限制'
      },
      confirmPassword: {
        label: '確認新密碼'
      }
    }
  }
};
